import React from 'react';
import { useLocation, Link } from 'react-router-dom';

const DynamicBreadcrumbs = ({ is404 = false, doctorName = '', doctorId = '' }) => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  const capitalizeFirstLetter = (str) => {
    return str
      .replace(/[-_]/g, ' ') // replace hyphens and underscores with spaces
      .split(' ')            // split into words
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // capitalize each word
      .join(' ');
  };

  // Function to check if string is base64 encoded
  const isBase64 = (str) => {
    try {
      return btoa(atob(str)) === str;
    } catch (err) {
      return false;
    }
  };

  // Filter out the last part if it's base64 encoded
  const filteredPathnames = pathnames.filter((value, index) => {
    if (index === pathnames.length - 1 && isBase64(value)) {
      return false;
    }
    return true;
  });

  return (
    <div className="dc-breadcrumbarea" style={{ background: '#ffffff' }}>
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <ol className="dc-breadcrumb">
              <li className="dc-item-home">
                <Link to="/" title="Home">Home</Link>
              </li>
              {is404 ? (
                <li className="dc-item-current">
                  <span className="dc-bread-current">Error 404</span>
                </li>
              ) : (
                filteredPathnames.map((value, index) => {
                  const pathTo = `/${filteredPathnames.slice(0, index + 1).join('/')}`;

                  return (
                    <li key={pathTo} className="dc-item-current">
                      {index === filteredPathnames.length - 1 ? (
                        <span className="dc-bread-current">{capitalizeFirstLetter(value)}</span>
                      ) : (
                        <Link to={pathTo}>{capitalizeFirstLetter(value)}</Link>
                      )}
                    </li>
                  );
                })
              )}
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DynamicBreadcrumbs;
